import React from 'react';

export default {
  continueButtonLabel: 'Continuar',
  goBackButtonLabel: 'Volver',
  search: {
    title: 'Encuentre el nombre de dominio ideal para su negocio',
    inputLabel: 'Escriba su dominio aquí (ej: minegocio.com)',
    offer: (
      <>
        <strong>Oferta especial:</strong>
        {' '}
        Contrate un dominio
        {' '}
        <strong>.com</strong>
        {' '}
        y obtenga
        {' '}
        <strong className="freeDomain">.online</strong>
        {' '}
        y
        {' '}
        <strong className="freeDomain">.store</strong>
        {' '}
        gratis durante el primer año.
      </>
    ),
    footerText: 'Seleccione un dominio para continuar',
    error: {
      title: 'No fue posible buscar el dominio.',
      description: 'Por favor, intente nuevamente en unos instantes.',
    },
  },
  list: {
    domainDescription: {
      com: (
        <>
          {'El '}
          <strong>más buscado</strong>
          {' en el mundo'}
        </>
      ),
      net: (
        <>
          {'Altamente '}
          <strong>confiable</strong>
        </>
      ),
      org: (
        <>
          {'Su organización '}
          <strong>destacada</strong>
        </>
      ),
      store: (
        <>
          {'Ideal para su '}
          <strong>tienda virtual</strong>
        </>
      ),
      online: (
        <>
          {'Moderno y '}
          <strong>flexible</strong>
        </>
      ),
      tech: (
        <>
          {'Moderno y '}
          <strong>directo al punto</strong>
        </>
      ),
    },
    optionsCycle: {
      one: 1,
      two: 2,
      three: 3,
      year: number => `Año${number > 1 ? 's' : ''}`,
    },
    radixLabel: 'GRATIS POR 1 AÑO',
    thenLabel: ({ value, cycle }) => {
      const rules = {
        1: 'año',
        2: 'bienal',
        3: 'trienal',
      };
      return `Después: ${value} / ${rules[cycle]}`;
    },
    domainInUse: 'Dominio en uso',
    domainInUseList: {
      title: 'Qué puede hacer:',
      infoList: [
        ' • Buscar otro nombre de dominio',
        ' • Elegir otras sugerencias con el mismo nombre',
      ],
    },
    protectID: {
      title: 'Sin protección, sus datos estarán visibles para cualquiera. ¡Evite estafas y correos no deseados!',
      description: ({ price, cycle }) => {
        const rules = {
          one: 'anual',
          two: 'bienal',
          three: 'trienal',
        };

        return (
          <>
            {'Active el ID Protect y mantenga su información oculta por '}
            <strong>
              {'solo '}
              {price}
              {`${`/${rules[cycle]}`}`}
            </strong>
            . Renovación automática.
          </>
        );
      },
    },
  },
};
